/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Freefeature41Inputs */

const zh_plan_freefeature41 = /** @type {(inputs: Plan_Freefeature41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`单文件上传限制 100MB`)
};

const en_plan_freefeature41 = /** @type {(inputs: Plan_Freefeature41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100MB per file upload limit`)
};

const es_plan_freefeature41 = /** @type {(inputs: Plan_Freefeature41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Límite de 100MB por archivo`)
};

/**
* | output |
* | --- |
* | "100MB per file upload limit" |
*
* @param {Plan_Freefeature41Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const plan_freefeature41 = /** @type {((inputs?: Plan_Freefeature41Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Freefeature41Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_plan_freefeature41(inputs)
	if (locale === "en") return en_plan_freefeature41(inputs)
	return es_plan_freefeature41(inputs)
});
export { plan_freefeature41 as "plan_freeFeature4" }